import { useState, useEffect } from 'react';
import { getSpotifyPremiumStatus } from '../utils/spotify-auth';

export function useSpotifyStatus() {
  const [status, setStatus] = useState({
    isPremium: false,
    isLoading: true,
    error: null
  });

  useEffect(() => {
    async function checkStatus() {
      try {
        const isPremium = await getSpotifyPremiumStatus();
        setStatus({
          isPremium,
          isLoading: false,
          error: null
        });
      } catch (error) {
        setStatus({
          isPremium: false,
          isLoading: false,
          error: error.message
        });
      }
    }

    checkStatus();
  }, []);

  return status;
}